import 'react';
import '../scss/on-category.scss';

export default () => null;
